import {isMac} from '@wandb/weave/common/util/browser';

export const HOTKEYS = {
  appSearch: ['⌘', 'K'], // stealing the quick nav pattern from the Slack App
  undoWorkspaceAction: ['⌘', 'Z'],
  redoWorkspaceAction: ['⌘', '⇧', 'Z'],
  saveWorkspace: ['⌘', 'S'],
  nextStep: ['⌘', 'ArrowRight'],
  prevStep: ['⌘', 'ArrowLeft'],
  zoomIn: ['⌘', '+'],
  zoomOut: ['⌘', '-'],
  zoomTo100: ['⌘', '0'],
  zoomToFit: ['Shift', '1'],
};

// for non-mac OS
export const HOTKEYS_FALLBACK = {
  appSearch: ['ctrl', 'K'],
  undoWorkspaceAction: ['ctrl', 'z'],
  redoWorkspaceAction: ['ctrl', 'y'],
  saveWorkspace: ['ctrl', 's'],
  nextStep: ['ctrl', 'ArrowRight'],
  prevStep: ['ctrl', 'ArrowLeft'],
  zoomIn: ['ctrl', '+'],
  zoomOut: ['ctrl', '-'],
  zoomTo100: ['ctrl', '0'],
  zoomToFit: ['Shift', '1'],
};

export const HOTKEY_KEY_TO_DISPLAY_MAP = {
  ArrowRight: '→',
  ArrowLeft: '←',
};

export const hotkeyDisplayString = (hotkey: keyof typeof HOTKEYS): string[] => {
  const hotkeyCombo = hotkeyString(hotkey);
  return hotkeyCombo.map(
    key =>
      HOTKEY_KEY_TO_DISPLAY_MAP[
        key as keyof typeof HOTKEY_KEY_TO_DISPLAY_MAP
      ] ?? key
  );
};

export const hotkeyString = (hotkey: keyof typeof HOTKEYS): string[] => {
  if (!isMac && hotkey in HOTKEYS_FALLBACK) {
    return HOTKEYS_FALLBACK[hotkey];
  }
  return HOTKEYS[hotkey];
};

export const hotkeyPressed = (
  e: KeyboardEvent,
  hotkey: keyof typeof HOTKEYS
) => {
  const combo = hotkeyString(hotkey);
  for (const part of combo) {
    switch (part) {
      case 'command':
      case '⌘':
        if (!e.metaKey) {
          return false;
        }
        break;
      case 'ctrl':
        if (!e.ctrlKey) {
          return false;
        }
        break;
      case 'alt':
      case 'option':
      case '⌥':
        if (!e.altKey) {
          return false;
        }
        break;
      case '⇧':
      case 'shift':
        if (!e.shiftKey) {
          return false;
        }
        break;
      default:
        if (e.key.toLowerCase() !== part.toLowerCase()) {
          return false;
        }
        break;
    }
  }
  return true;
};
